import clsx from 'clsx';
import { ReactNode } from 'react';

export const Hero = ({
  title,
  subtitle,
  surtitle,
  illustration,
  leftIllustation,
  className,
  children,
}: {
  title: string;
  subtitle?: string;
  surtitle?: string;
  illustration?: ReactNode;
  leftIllustation?: string;
  className?: string;
  children?: ReactNode;
}) => {
  return (
    <div className={clsx('bg-blue-50 border-b border-gray-100', className)}>
      <div className="main-content">
        <div className="flex items-center  py-8 min-h-40 gap-8">
          {leftIllustation && <img className="w-24" src={leftIllustation} />}
          <div className="flex items-center justify-between">
            <div
              className={clsx('space-y-2', illustration ? 'w-2/3' : 'w-full')}
            >
              {surtitle && <div className="text-gray-500">{surtitle}</div>}
              <h1>{title}</h1>
              {subtitle && <div>{subtitle}</div>}
            </div>
            {illustration && <div>{illustration}</div>}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
